import React from "react";

import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import ArchiveActionMenuLabel from "./ArchiveActionMenuLabel";

export const getArchiveActionMenuItem = (schemaField: SchemaField) => {
  const disabled = !schemaField.canArchive || schemaField.usedInWorkflow;
  return {
    disabled,
    key: "archive",
    label: <ArchiveActionMenuLabel disabled={disabled} field={schemaField} />,
  };
};
